export const state = () => ({
    categoryPageSEOData: {},
    categories: {},
    filters: {},
    dsFilters: {},
    sorts: {},
    seoPages: {},
    eventMarketPlaceBanners: {},

    // Cached Prismic links for the header navigation
    navigation: null,
})

export const getters = {
    categories(state) {
        return state.categories
    },
    filters(state) {
        return state.filters
    },
    dsFilters(state) {
        return state.dsFilters
    },
    storefrontFilters(state) {
        return state.storefrontFilters
    },
    allFilterAttributes(state) {
        return state.filters.map((item) => item.attribute)
    },
    sorts(state) {
        return state.sorts
    },
    seoPages(state) {
        return state.seoPages
    },
    navigation(state) {
        return state.navigation
    },
    marketplaceSEOTitle(state) {
        return (
            state.categoryPageSEOData?.metaTitle ||
            state.categoryPageSEOData?.title ||
            ''
        )
    },
    marketplaceSEOFilters(state) {
        return state.categoryPageSEOData?.attributes || []
    },
    marketplaceCustomSEOPath(state) {
        return state.categoryPageSEOData?.path || ''
    },
    marketplaceSEOMetaTitle(state) {
        return state.categoryPageSEOData?.metaTitle || ''
    },
    marketplaceSEOMetaDescription(state) {
        return state.categoryPageSEOData?.metaDescription || ''
    },
    getEventMarketPlaceBanners() {
        return window.Store?.marketplace.banners || {}
    },
}

export const mutations = {
    updateCategorySEOData(state, payload = {}) {
        state.categoryPageSEOData = payload
    },
    updateCategories(state, payload = {}) {
        state.categories = payload
    },
    updateFilters(state, payload = {}) {
        state.filters = payload
    },
    updateDsFilters(state, payload = {}) {
        state.dsFilters = payload
    },
    updateStorefrontFilters(state, payload = {}) {
        state.storefrontFilters = payload
    },
    updateSorts(state, payload = {}) {
        state.sorts = payload
    },
    updateSeoPages(state, payload = {}) {
        state.seoPages = payload
    },
    updateNavigation(state, payload = {}) {
        state.navigation = payload
    },
}

export const actions = {
    updateCategories(context, payload) {
        context.commit('updateCategories', payload)
    },
    updateFilters(context, payload) {
        context.commit('updateFilters', payload)
    },
    updateDsFilters(context, payload) {
        context.commit('updateDsFilters', payload)
    },
    updateStorefrontFilters(context, payload) {
        context.commit('updateStorefrontFilters', payload)
    },
    updateSorts(context, payload) {
        context.commit('updateSorts', payload)
    },
    updateSeoPages(context, payload) {
        context.commit('updateSeoPages', payload)
    },
    updateNavigation(context, payload) {
        context.commit('updateNavigation', payload)
    },
}
